import { cartClient } from '../common/cartClient';
import type {
  AddToCartRequest,
  AddToCartResponse,
  ApplyCouponRequest,
  ApplyCouponResponse,
  DeleteCartRequest,
  DeleteCartResponse,
  GetCartRequest,
  GetCartResponse,
  RemoveCouponRequest,
  RemoveCouponResponse,
  UpdateCartItemRequest,
  UpdateCartItemResponse,
} from './utils/types';

class CartAPIClient {
  public async getCart(params?: GetCartRequest): Promise<GetCartResponse> {
    return await cartClient.get('/cart', { params }).then((res) => res.data);
  }

  public async addToCart(payload: AddToCartRequest): Promise<AddToCartResponse> {
    return await cartClient.post('/cart/add', payload).then((res) => res.data);
  }

  public async updateCartItem({ itemKey, ...payload }: UpdateCartItemRequest): Promise<UpdateCartItemResponse> {
    return await cartClient.put(`/cart/items/${itemKey}`, payload).then((res) => res.data);
  }

  public async deleteCartItem({ itemKey, ...payload }: DeleteCartRequest): Promise<DeleteCartResponse> {
    return await cartClient.delete(`/cart/items/${itemKey}`, { data: payload }).then((res) => res.data);
  }

  public async applyCoupon(payload: ApplyCouponRequest): Promise<ApplyCouponResponse> {
    return await cartClient.post('/cart/applyCoupon', payload).then((res) => res.data);
  }

  public async removeCoupon(payload: RemoveCouponRequest): Promise<RemoveCouponResponse> {
    return await cartClient.delete('/cart/removeCoupon', { data: payload }).then((res) => res.data);
  }
}

export const cartAPIClient = new CartAPIClient();
